import { render, staticRenderFns } from "./DevicesStatsPanel.vue?vue&type=template&id=088e0204&scoped=true&"
import script from "./DevicesStatsPanel.vue?vue&type=script&lang=js&"
export * from "./DevicesStatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./DevicesStatsPanel.vue?vue&type=style&index=0&id=088e0204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088e0204",
  null
  
)

export default component.exports